import { useEffect } from 'react'

interface useInitProps {
  getValues: Function
  reset: Function
  setDataLoaded: Function
  setShowOverlay: Function
  currentCustomer: {} | null
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    props.setDataLoaded(true)
    props.setShowOverlay(false)
  }, [props.currentCustomer])
}

export default useInit
